#!/usr/bin/env node

import { main } from './translator.js';

main();
